
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class InlineLoader extends Vue {
  @Prop({ type: String, default: null }) readonly label?: string;

  get computedLabel() {
    return this.label ?? this.$tc("defaultLabel");
  }
}
